<template>
    <div>
        <div class="bg-grey vh-100" id="listkomisix">

            <!-- HEADER -->
            <div class="header-top bg-white showPageDefault">
                <div class="header-top--inner w-limit d-flex justify-content-between align-items-center">
                    <div class="header-top--left" @click="backtolistpenggajian">
                        <div class="header-item">
                            <img src="../../../assets/icons/back-blue.svg" alt="a">
                        </div>
                    </div>
                    <div class="header-top--middle f-cont f-16 f-bold">Daftar Jenis Komisi</div>
                    <div class="header-top--right" v-on:click="Searchkomisix">
                        <div class="header-item">
                            <img src="../../../assets/icons/search.svg" alt="">
                        </div>
                    </div>
                </div>
            </div>

            <div class="header-top bg-white showPageSearch fix-header-top">
                <div class="header-top--inner w-limit d-flex justify-content-between align-items-center">
                    <div class="header-top--left add-padding-default">
                        <input class="inputSearch" id="input_searchKomisix" type="text" v-on:keyup="searchKomisix" v-model="searchKeykomisix"
                               placeholder="Cari..">
                    </div>
                    <div class="header-top--right" v-on:click="closeSearchkmisix">
                        <div class="header-item">
                            <img src="../../../assets/img/x2.svg" alt="">
                        </div>
                    </div>
                </div>
            </div>

            <div class="showPageSearch">
                <!-- CONTENT -->
                <div class="content-wrapper main-page" v-if="listkomisiPsearch.length >= 0">
                    <div class="Search-BOX mar-top-16 add-padding-default mar-bottom-16" id="textTopKomisix"></div>
                    <!-- ITEMS -->
                    <div class="p-x-20 p-y-16 w-limit">
                        <!-- LIST ITEMS -->
                        <div class="card-item-wrapper">
                            <div class="card-item"  v-for="listkomisixSearch in listkomisiPsearch" :key="listkomisixSearch.id" >
                                <div class="clik" style="" :id="'dropdownMenuLinklistkomisi'+listkomisixSearch.id" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></div>
                                <div class="top-card" >
                                    <div class="f-16 f-semi" v-html="searchHighlight(listkomisixSearch.nama, searchKeykomisix)"></div>
                                    <div class="card-menu-vertical">
                                    </div>
                                </div>
                                <div class="m-t-6 d-flex-align-center">
                                    <div class="icon-16 icon-sales m-r-6"></div>
                                    <div class="f-14 f-c-midgrey">{{listkomisixSearch.lenghdata_detailkomisi}} Target Penjualan</div>
                                </div>
                                <div class="m-t-2 d-flex-align-center">
                                    <div class="icon-16 icon-check-circle m-r-6"></div>
                                    <div class="f-14 f-c-midgrey">{{listkomisixSearch.dihitung_nota}}</div>
                                </div>
                                <div class="dropdown-menu garis-listkomisi">
                                    <a class="dropdown-item icon-1" href="#"><span
                                            class="mar-right-10"><i class="far fa-edit color-206CF"></i></span>Ubah</a>
                                    <div class="dropdown-item icon-2" href="#" @click="showmodaldelkomisix(listkomisixSearch)"><span
                                            class="mar-right-10"><img src="../../../assets/icons/trash-2.svg"></span>Hapus</div>
                                </div>
                            </div>
	                        <div class="loadmoreSpinner" id="loadingSpinnerListKomisiSearch" style="display: none">
		                        <center>
			                        <div class="sp sp-circle"></div>
		                        </center>
	                        </div>

                        </div>

                    </div>
                </div>
            </div>

            <div class="showPageDefault">
                <!-- CONTENT -->
                <div class="content-wrapper main-page" v-if="leght_data_komisix ===0">

                    <!-- IF EMPTY -->
                    <div class="empty-state display-none">
                        <div class="empty-state--icon"></div>
                        <div class="f-16 f-bold">Belum ada komisi terdaftar</div>
                        <div class="f-14 f-c-midgrey">Klik tombol + untuk menambahkan</div>
                    </div>
                </div>

                <div class="content-wrapper main-page" v-else>
                    <!-- ITEMS -->
                    <div class="p-x-20 p-y-16 w-limit">

                        <div class="d-flex justify-content-between m-d-16">
                            <div class="f-16 f-c-midgrey">Total {{leght_data_komisix}} Komisi</div>

	                        <FilterSorting @filter="filter" :jenisFilter="'listKomisi'" style="margin-top: -6px"/>
                        </div>

                        <!-- LIST ITEMS -->
                        <div class="card-item-wrapper">

                            <div class="card-item"  v-for="listkomisix in listkomisiP" :key="listkomisix.id" >
                                <div class="clik" style="" :id="'dropdownMenuLinklistkomisi'+listkomisix.id" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></div>
                                <div class="top-card" >
                                    <div class="f-16 f-semi">{{listkomisix.nama}}</div>
                                    <div class="card-menu-vertical">
                                    </div>
                                </div>
                                <div class="m-t-6 d-flex-align-center">
                                    <div class="icon-16 icon-sales m-r-6"></div>
                                    <div class="f-14 f-c-midgrey">{{listkomisix.lenghdata_detailkomisi}} Target Penjualan</div>
                                </div>
                                <div class="m-t-2 d-flex-align-center">
                                    <div class="icon-16 icon-check-circle m-r-6"></div>
                                    <div class="f-14 f-c-midgrey">{{listkomisix.dihitung_nota}}</div>
                                </div>
                                <div class="dropdown-menu garis-listkomisi">
                                    <a class="dropdown-item icon-1" href="#" v-if="validateAccess('payrollSalesCommision.update')" @click="editkomisix(listkomisix.id)"><span
                                            class="mar-right-10"><i class="far fa-edit color-206CF"></i></span>Ubah</a>
                                    <div class="dropdown-item icon-2" href="#" v-if="validateAccess('payrollSalesCommision.delete')" @click="showmodaldelkomisix(listkomisix)"><span
                                            class="mar-right-10"><img src="../../../assets/icons/trash-2.svg"></span>Hapus</div>
                                </div>
                            </div>
	                        <div class="loadmoreSpinner" id="loadingSpinnerListKomisi" style="display: none">
		                        <center>
			                        <div class="sp sp-circle"></div>
		                        </center>
	                        </div>

                        </div>

                    </div>
                </div>
                <!-- PLUS ICON -->
                <div class="flying-button-wrapper" @click="createkomisip" v-if="validateAccess('payrollSalesCommision.create')">
                    <div class="w-limit flying-inside">
                        <div class="flying-button"></div>
                    </div>
                </div>
            </div>


            <div class="modal fade" id="modaldellistkomisix" role="dialog">
                <div class="modal-dialog modal-lg  bani-modal">
                    <div class="modal-content">
                        <div class="modal-head w-limit">
                            <div class="modal-head--left"></div>
                            <h5 class="f-16 f-bold">Hapus Jenis Komisi</h5>
                            <div class="modal-head--right" data-dismiss="modal">
                                <img src="../../../assets/img/x2.svg" alt="">
                            </div>
                        </div>
                        <div class="separator-line"></div>
                        <div class="modal-bodyy w-limit w-100 p-x-20">
                            <div class="p-t-16">
                                <div class="f-16">Yakin ingin menghapus <b>{{namakomisix}}?</b></div>
                            </div>
                            <div class="button-wrapper m-t-4 p-d-20 p-t-24 w-limit w-100" @click="Deletekomisix">
                                <div class="btn smart-primary">Ya, Hapus</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import FilterSorting from "@/component-items/FilterSorting";

export default {
    name: "listKomisix",
	components: { FilterSorting },
    data(){
        return{
            listkomisiP:[],
            listkomisiPsearch:[],
            namakomisix:'',
            idkomisix:'',
            komisixSearch:[],
            searchKeykomisix:'',
            leght_data_komisix:'',
            requestHeaders: {
                headers: {
                    'Authorization': 'Bearer ' + localStorage.getItem('token'),
                }
            },
	
	        listKomisiPagination: {
		        limit: 20,
		        offset:0,
		        length: 0,
		        pageNumber: 0,
		        sortBy: "nama",
		        orderBy: "ASC",
	        },
	        listKomisiSearchPagination: {
		        limit: 20,
		        offset:0,
		        length: 0,
		        pageNumber: 0,
		        sortBy: "nama",
		        orderBy: "ASC",
		        key: "",
	        },
        }
    },
    mounted() {
        this.listkomisi()
        $(".showPageSearch").prop("style", "display:none");
        this.scroll()

	    this.backButtonPressed(this.backtolistpenggajian)
    },
    methods:{
	    scroll() {
		    window.onscroll = () => {
			    if ($('#loadingSpinnerListKomisi').is(":hidden")) {
				    if ($(".showPageDefault").is(":visible")) {
					    if (this.listKomisiPagination.pageNumber <= Math.ceil(this.listKomisiPagination.length / this.listKomisiPagination.limit)) {
						    if (Math.floor($(window).scrollTop()) > 0 && Math.floor($(window).scrollTop()) >= Math.floor($(document).height() - $(window).height()) - 100) {
							    this.listKomisiPagination.offset = (this.listKomisiPagination.pageNumber * this.listKomisiPagination.limit);
							    if (this.listKomisiPagination.offset > 0) {
							    	this.listkomisi();
							    }
							    $('#loadingSpinnerListKomisi').show()
						    }
					    }
				    }
			    }
			
			    if ($('#loadingSpinnerListKomisiSearch').is(":hidden")) {
				    if ($(".showPageSearch").is(":visible")) {
					    if (this.listKomisiSearchPagination.pageNumber <= Math.ceil(this.listKomisiSearchPagination.length / this.listKomisiSearchPagination.limit)) {
						    if (Math.floor($(window).scrollTop()) > 0 && Math.floor($(window).scrollTop()) >= Math.floor($(document).height() - $(window).height()) - 100) {
							    this.listKomisiSearchPagination.offset = (this.listKomisiSearchPagination.pageNumber * this.listKomisiSearchPagination.limit);
							    this.searchKomisix();
							    $('#loadingSpinnerListKomisiSearch').show()
						    }
					    }
				    }
			    }
		    }
	    },
        closeSearchkmisix(){
            $(".showPageSearch").hide()
            $(".showPageSearch").removeClass('animated slideInDown')
            $(".showPageDefault").show();
            this.komisixSearch = "";
            this.searchKeykomisix = "";
            $("#textTopRak").text("Minimal 3 karakter")
	        this.listkomisiPsearch = []
	        this.listKomisiSearchPagination = {
		        limit: 20,
		        offset:0,
		        length: 0,
		        pageNumber: 0,
		        sortBy: "nama",
		        orderBy: "ASC",
		        key: "",
	        }
        },

        backtolistpenggajian(){
            this.$emit('backtolistpenggajian');
        },

        createkomisip(){
            this.$emit('gotocreatepenggajian');
        },

        showmodaldelkomisix(listkomisix) {
            this.idkomisix = listkomisix.id;
            this.namakomisix=listkomisix.nama;
            $('#modaldellistkomisix').modal('show')
        },

        editkomisix(id){
            this.$emit('showeditkomisix',id)
        },

        Searchkomisix(){
            $(".showPageSearch").show()
            $(".showPageSearch").addClass('animated slideInDown')
            $("#textTopKomisix").text("Minimal 2 karakter")
            $(".showPageDefault").hide();
            $("#input_searchKomisix").focus();
        },

        searchKomisix() {
            $("#textTopKomisix").text("Minimal 2 karakter")
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            this.timer = setTimeout(() => {
                this.komisixSearch = "";
                // $(".spinner").prop("style", "display:inline-block");
                this.searchKomisixFunc();
            }, 500);
        },

        async searchKomisixFunc() {
            var key = this.searchKeykomisix
	        if (this.listKomisiSearchPagination.offset === 0 || this.listKomisiSearchPagination.key !== key) {
		        this.listkomisiPsearch = []
		        $('#loadingPage').show();
		        $('#loadingPage').addClass('overlayLoading');
		        $("#textTopKomisix").text("Sedang mencari...")
		        
		        this.listKomisiSearchPagination = {
			        limit: 20,
			        offset:0,
			        length: 0,
			        pageNumber: 0,
			        sortBy: "nama",
			        orderBy: "ASC",
			        key: key,
		        }
	        }
            if (key.length >= 2) {
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/list_jenis_komisi_sales?'+ '&key=' + key
	                    + '&limit=' + this.listKomisiSearchPagination.limit
	                    + '&offset=' + this.listKomisiSearchPagination.offset, this.requestHeaders);
                    if (response.status === 200) {
                        if (response.data.status === true) {
                            this.leght_data_komisix=response.data.lenght_data;
                            var data = response.data.data;
                            this.listKomisiSearchPagination.length = this.leght_data_komisix
	                        if (data.length > 0) {
		                        for (var i = 0; i < data.length; i++) {
			                        var jenisnota = data[i].dihitung_dari_nota ;
			                        var namajenisnota = "";
			                        if (jenisnota === 1){
				                        namajenisnota = "Nota Lunas Saja";
			                        }else{
				                        namajenisnota = "Semua Nota";
			                        }
			                        this.listkomisiPsearch.push({
				                        nama:data[i].nama,
				                        id:data[i].id,
				                        detailKomisi:data[i].detail_jenisgaji_sales,
				                        lenghdata_detailkomisi:data[i].detail_jenisgaji_sales.length,
				                        dihitung_nota:namajenisnota
			                        })
		                        }
	                        }
	                        this.listKomisiSearchPagination.pageNumber++
	                        $("#loadingSpinnerListKomisiSearch").hide()
                            $('#loadingPage').hide();
                            $('#loadingPage').removeClass('overlayLoading');
                            if(this.leght_data_komisix > 0){
                                $("#textTopKomisix").text("Ditemukan "+this.leght_data_komisix+" Komisi dengan kata '"+key+"'");
                            }else{
                                $("#textTopKomisix").text("Tidak menemukan '"+key+"'");
                            }
                        }
                    }
                } catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').hide();
	                $('#loadingPage').removeClass('overlayLoading');
                }
            } else {
                this.komisixSearch = "";
                $('#loadingPage').hide();
                $('#loadingPage').removeClass('overlayLoading');
                $("#textTopKomisix").text("Minimal 2 karakter")
            }
        },

        async listkomisi(){
	    	if (this.listKomisiPagination.offset === 0) {
			    this.listkomisiP = [];
			    $('#loadingPage').addClass('overlayLoading');
			    $('#loadingPage').show()
		    }
            try {
                const response = await this.$axios.get(this.$baseurl + '/masterData/meta/list_jenis_komisi_sales?'
	                + '&sort_by=' + this.listKomisiPagination.sortBy
	                + '&order_by='+ this.listKomisiPagination.orderBy
	                + '&limit=' + this.listKomisiPagination.limit
	                + '&offset=' + this.listKomisiPagination.offset, this.requestHeaders)
                if (response.data.status === true) {
                    $('#loadingPage').removeClass('overlayLoading');
                    $('#loadingPage').hide()
                    var data = response.data.data;
                    this.leght_data_komisix=response.data.lenght_data;
                    this.listKomisiPagination.length = this.leght_data_komisix
	                if (data.length > 0) {
		                for (var i = 0; i < data.length; i++) {
			                var jenisnota = data[i].dihitung_dari_nota ;
			                var namajenisnota = "";
			                if (jenisnota === 1){
				                namajenisnota = "Nota Lunas Saja";
			                }else{
				                namajenisnota = "Semua Nota";
			                }
			                this.listkomisiP.push({
				                nama:data[i].nama,
				                id:data[i].id,
				                detailKomisi:data[i].detail_jenisgaji_sales,
				                lenghdata_detailkomisi:data[i].detail_jenisgaji_sales.length,
				                dihitung_nota:namajenisnota
			                })
		                }
	                }
	                this.listKomisiPagination.pageNumber++
	                $('#loadingSpinnerListKomisi').hide()
                }
            }  catch (e) {
            	this.$catch_error_response(e)
	            $('#loadingPage').removeClass('overlayLoading');
	            $('#loadingPage').hide()
	            this.isClicked = false
	            $('#textBtn2').show()
	            $('#btnNext').prop('disabled', false);
            }
        },

        async Deletekomisix(){
            $('#loadingPage').show();
            $('#loadingPage').addClass('overlayLoading');
            try {
                const komisix = new FormData;
                komisix.append('idjeniskomisi', this.idkomisix)
                const response = await this.$axios.post(this.$baseurl + '/masterData/karyawan/delete_jenis_komisi_sales',komisix, this.requestHeaders);
                if(response.data.status===true){
                    document.documentElement.scrollTop = 0;
                    $('#modaldellistkomisix').modal('hide');
                    $('#loadingPage').removeClass('overlayLoading');
                    $('#loadingPage').hide();
                    this.listkomisi()
	                this.$toast.success(response.data.msg)
                }else{
                	this.$toast.error(response.data.msg)
                    $('#loadingPage').hide();
                    $('#loadingPage').removeClass('overlayLoading');
                }

            }catch (e) {
            	this.$catch_error_response(e)
	            $('#loadingPage').hide();
	            $('#loadingPage').removeClass('overlayLoading');
            }
        },

        async sortingkomisix(key) {
            $("#cardWorkshop").hide();
            $("#spinnerWorkshop").prop("style", "display:inline-block");
            switch (key) {
                case "asc":
                    $('#dropdownMenuButton2').text("Urut Dari A - Z ")
                    this.getsortingKomisix(1)
                    break;
                case "desc":
                    $('#dropdownMenuButton2').text("Urut Dari Z - A ")
                    this.getsortingKomisix(2)
                    break;
                case "terbaru":
                    $('#dropdownMenuButton2').text("Urut Dari Terbaru ")
                    this.getsortingKomisix(3)
                    break;
                case "terlama":
                    $('#dropdownMenuButton2').text("Urut Dari Terlama ")
                    this.getsortingKomisix(4)
                    break;
                default:
                    $('#dropdownMenuButton2').text("Urutkan ")
            }
        },
        async getsortingKomisix(komisix) {
            var sort_by
            var order_by
            //var key = jika ada search nanti dipake
            $('#loadingPage').show();
            $('#loadingPage').addClass('overlayLoading');
            try {
                if (komisix === 1) {
                    sort_by = "nama";
                    order_by = "ASC";
                } else if (komisix === 2) {
                    sort_by = "nama";
                    order_by = "DESC";
                } else if (komisix === 3) {
                    sort_by = "created_at";
                    order_by = "DESC";
                } else if (komisix === 4) {
                    sort_by = "created_at";
                    order_by = "ASC";
                } else {
                    return
                }
                // var idowner = localStorage.getItem('idowner');
                const response = await this.$axios.get(this.$baseurl + 'masterData/meta/list_jenis_komisi_sales?' + '&order_by=' + order_by + '&sort_by=' + sort_by, this.requestHeaders)
                if (response.status === 200) {
                    if (response.data.status === true) {
                        this.listkomisiP=[];
                        var data = response.data.data
                        for (var i = 0; i < data.length; i++) {
                            var data = response.data.data;
                            for (var i = 0; i < data.length; i++) {
                                var jenisnota = data[i].dihitung_dari_nota ;
                                var namajenisnota = "";
                                if (jenisnota === 1){
                                    namajenisnota = "Nota Lunas Saja";
                                }else{
                                    namajenisnota = "Semua Nota";
                                }
                                this.listkomisiP.push({
                                    nama:data[i].nama,
                                    id:data[i].id,
                                    detailKomisi:data[i].detail_jenisgaji_sales,
                                    lenghdata_detailkomisi:data[i].detail_jenisgaji_sales.length,
                                    dihitung_nota:namajenisnota
                                })
                            }
                            $('#loadingPage').hide();
                            $('#loadingPage').removeClass('overlayLoading');
                        }
                    }
                }
            } catch (e) {
            	this.$catch_error_response(e)
	            $('#loadingPage').hide();
	            $('#loadingPage').removeClass('overlayLoading');
            }
        },
	    async filter(payload) {
		    this.listKomisiPagination = payload.data
		    await this.listkomisi();
		    $("#dropdownMenuButton-" + payload.type).html(payload.textSorting)
	    }
    }
}
</script>

<style>

</style>